var RETAILERS_API_CONFIG = {
    baseUrl: '',
    marketLocale: '',
};
export var getRetailersApiConfig = function () {
    return RETAILERS_API_CONFIG;
};
export var setRetailersApiConfig = function (config) {
    RETAILERS_API_CONFIG.baseUrl = config.baseUrl;
    RETAILERS_API_CONFIG.marketLocale = config.marketLocale;
};
